/* @flow */

const ERROR_SELECTOR = [
  '[data-form-error]',
  '.MuiFormControl-root .Mui-error',
  '.MuiFormHelperText-root.Mui-error',
  '.MuiInputBase-root.Mui-error',
  '.MuiFormLabel-root.Mui-error',
  '.MuiFormControlLabel-root.Mui-error',
  '.MuiAlert-standardError',
  '.MuiAlert-filledError',
  '.MuiAlert-outlinedError'
].join(',');

const getElementTop = (element: HTMLElement) => element.getBoundingClientRect().top;

const isVisible = (element: HTMLElement) => {
  const rect = element.getBoundingClientRect();
  const style = window.getComputedStyle(element);
  return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
};

const getScrollTarget = (element: HTMLElement) => (
  element.closest('[data-form-error], .MuiFormControl-root, .MuiFormControlLabel-root, .MuiAlert-root') || element
);

const getErrorElements = () => {
  const elements = Array.prototype.slice.call(document.querySelectorAll(ERROR_SELECTOR));

  return elements
    .map(getScrollTarget)
    .filter((element, index, self) => element && isVisible(element) && self.indexOf(element) === index)
    .sort((a, b) => getElementTop(a) - getElementTop(b));
};

export default function scrollToFormError() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const scroll = () => {
    const errors = getErrorElements();
    if (!errors.length) return;

    errors[0].scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  };

  if (window.requestAnimationFrame) {
    window.requestAnimationFrame(scroll);
    return;
  }

  setTimeout(scroll, 0);
}